export const initUiButtonFocusedOnClick = () => {
  $(document).on("click", function(event) {
    if ($(event.target).closest(".ui-button").length) {
      $(".ui-button").removeClass("ui-button--is-focused");
      $(event.target)
        .closest(".ui-button")
        .addClass("ui-button--is-focused");
    } else {
      $(".ui-button").removeClass("ui-button--is-focused");
    }
  });
};
